// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6c74fef1","732":"8d80fe5e","977":"ff8195e2"}[chunkId] + ".chunk.js";
};